import axios from 'axios'
import api, { getResponseError } from '../../services/api'
import {
  TChargebackDispute,
  TChargebackDisputePagination,
} from '../types/ChargebackDispute'
import { IErrorResponse } from '../types/ErrorResponse'

const NOT_FOUND: IErrorResponse = {
  code: 404,
  error: 'Disputa não encontrada',
}

const toError = (error: unknown): IErrorResponse => {
  if (axios.isAxiosError(error) && error.response?.status === 404) {
    return NOT_FOUND
  }
  return { code: 2, error: getResponseError(error) }
}

interface IGetAllProp {
  onlyOpen: boolean
  page: number
  rows: number
  // Nome ou e-mail do produtor; o back só aplica para o admin
  search?: string
}

const getAll = async ({
  onlyOpen,
  page,
  rows,
  search,
}: IGetAllProp): Promise<TChargebackDisputePagination | IErrorResponse> => {
  try {
    let path = `/ChargebackDispute?onlyOpen=${onlyOpen}&pageNumber=${page}&rowsPerPage=${rows}`
    if (search) {
      path += `&search=${encodeURIComponent(search)}`
    }
    const { data } = await api.get<TChargebackDisputePagination>(path)
    if (data) {
      return data
    }
    return { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return toError(error)
  }
}

const get = async ({
  id,
}: {
  id: string
}): Promise<TChargebackDispute | IErrorResponse> => {
  try {
    const { data } = await api.get<TChargebackDispute>(
      `/ChargebackDispute/${id}`
    )
    if (data) {
      return data
    }
    return { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return toError(error)
  }
}

// 400 traz em `detail` o motivo (gateway sem suporte ou disputa ainda não sincronizada)
const getByCharge = async ({
  orderChargeId,
}: {
  orderChargeId: string
}): Promise<TChargebackDispute | IErrorResponse> => {
  try {
    const { data } = await api.get<TChargebackDispute>(
      `/ChargebackDispute/by-charge/${orderChargeId}`
    )
    if (data) {
      return data
    }
    return { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return toError(error)
  }
}

// ponytail: falha vira 0, o sino só some; não vale toast na navbar
const getOpenCount = async (): Promise<number> => {
  try {
    const { data } = await api.get<number>('/ChargebackDispute/open-count')
    return typeof data === 'number' ? data : 0
  } catch {
    return 0
  }
}

const sendEvidences = async ({
  id,
  files,
}: {
  id: string
  files: File[]
}): Promise<IErrorResponse | undefined> => {
  try {
    const form = new FormData()
    // ASP.NET só reconhece o campo repetido "files" (não "files[]")
    files.forEach((file) => form.append('files', file))
    await api.post(`/ChargebackDispute/${id}/evidences`, form)
    return undefined
  } catch (error) {
    return toError(error)
  }
}

const ChargebackDisputeController = {
  getAll,
  get,
  getByCharge,
  getOpenCount,
  sendEvidences,
}

export default ChargebackDisputeController
